<template>
  <div class="xndetails">
    <!-- 资源简介 -->
    <div class="header_top">
      <div class="light"></div>
      <div v-if="sucxinxi == null">
        <el-empty description="加载中..."></el-empty>
      </div>
      <div class="hdtop_content" v-else>
        <div class="hdcontent_left">
          <h1>
            {{ sucxinxi.material.title }}
            <span v-if="sucxinxi.material.bilingual == 1" class="zhen-icon"
              >中英双语</span
            >
          </h1>
          <div class="left_listbtn">
            <el-button
              class="lefbtn"
              :class="sucxinxi.collected == true ? 'icolorb ' : 'icolora'"
              size="mini"
              :icon="
                sucxinxi.collected == true ? 'el-icon-star-on ' : 'el-icon-star-off '
              "
              @click="collction"
              :loading="divloading"
              >收藏</el-button
            >
            <el-button
              class="lefbtn"
              :class="sucxinxi.pros == 0 ? 'icolorb' : 'icolora'"
              :loading="zanloading"
              size="mini"
              @click="fabuloubtns(0)"
            >
              <i class="goodicon"></i> 点赞 {{ sucxinxi.material.pros }}</el-button
            >
            <el-button
              class="lefbtn icolora"
              size="mini"
              icon="el-icon-share"
              @click="copyurls"
              >复制链接分享</el-button
            >
          </div>
          <!-- 资源信息 -->
          <div class="ziy_miaoshu">
            <span>最新发布时间：{{ sucxinxi.material.createTime }}</span>
            <span>文件大小：{{ sucxinxi.material.fileSize | calSize }}</span>
            <span>发布人：{{ sucxinxi.material.createName }}</span>
          </div>
          <!-- 所属类 -->
          <div class="ziy_class">
            <div class="type_list" v-for="(item, index) in sucxinxi.types" :key="index">
              <span>{{ item.typeBig }} :</span> <span>{{ item.typeSmalls }}</span>
            </div>
          </div>
          <!-- 介绍 -->
          <div class="zy_detailtxt">
            <p>{{ sucxinxi.material.description }}</p>
          </div>
          <!--实验链接 -->
          <div class="shiy_link">
            <el-button class="shiy_btn" @click="zuopshiy">我要做实验</el-button>
          </div>
        </div>
        <!-- 实验简介视频 挪到首页了先隐藏掉 -->
        <div class="hdcontent_rig" v-if="false">
          <div class="tabs_rig">
            <el-radio-group v-model="tabPosition">
              <el-radio-button label="1">基地简介视频</el-radio-button>
              <el-radio-button v-if="formatUrl(sucxinxi.material.teachingUrl)" style="margin-left: 5px" label="2"
                >虚拟仿真体验中心</el-radio-button
              >
            </el-radio-group>
            <div class="vid_active" v-show="tabPosition == '1'">
              <div
                class="emnull"
                v-if="
                  sucxinxi.material.introductionUrl == null ||
                  sucxinxi.material.introductionUrl == '' ||
                  sucxinxi.material.introductionUrl == undefined
                "
              >
                <el-empty :image-size="100" description="暂无资源"></el-empty>
              </div>
              <video
                v-else
                :src="formatUrl(sucxinxi.material.introductionUrl)"
                controls
                controlsList="nodownload"
              ></video>
            </div>
            <div class="vid_active" v-show="tabPosition == '2'">
              <div
                class="emnull"
                v-if="
                  sucxinxi.material.teachingUrl == null ||
                  sucxinxi.material.teachingUrl == '' ||
                  sucxinxi.material.teachingUrl == undefined
                "
              >
                <el-empty :image-size="100" description="暂无资源"></el-empty>
              </div>
              <video
                v-else
                :src="formatUrl(sucxinxi.material.teachingUrl)"
                controls
                controlsList="nodownload"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 实验介绍 -->
    <div class="shiy_tab">
      <div class="shiy_center">
        <el-radio-group v-model="sytabactive">
          <el-radio-button label="1">实验介绍</el-radio-button>
          <el-radio-button style="margin-left: 10px" label="2">实验必读</el-radio-button>
          <el-radio-button style="margin-left: 10px" label="3">实验讨论</el-radio-button>
        </el-radio-group>
        <!-- <div class="sharing">
          <div class="sharing_item">
            <div class="sharing_title">
              <i class="el-icon-view"></i>
              浏览量
            </div>
            <p>1231</p>
          </div>
          <div class="sharing_item">
            <div class="sharing_title">
              <i class="el-icon-s-promotion"></i>
              实验人次
            </div>
            <p>1212</p>
          </div>
          <div class="sharing_item">
            <div class="sharing_title">
              <i class="el-icon-user"></i>
              实验人数
            </div>
            <p>1233</p>
          </div>
          <div class="sharing_item">
            <div class="sharing_title">
              <i class="el-icon-time"></i>
              实验平均用时
            </div>
            <p>39'</p>
          </div>
          <div class="sharing_item">
            <div class="sharing_title">
              <i class="el-icon-circle-check"></i>
              实验完成率
            </div>
            <p>100%</p>
          </div>
          <div class="sharing_item">
            <div class="sharing_title">
              <i class="el-icon-finished"></i>
              实验通过率
            </div>
            <p>100%</p>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 资料内容 -->
    <div class="syzl_listall">
      <div v-if="sucxinxi == null">
        <el-empty description="加载中..."></el-empty>
      </div>
      <div class="syzl_content" v-else>
        <div class="syzl_tabtxt" v-if="sytabactive == '1'">
          <el-tabs tab-position="top" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in readingone"
              :key="index"
              :label="item.name"
              :name="item.name"
            >
              <div class="editor—wrapper" v-html="item.content.replace(/\/dev-api/g,baseurl)"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="syzl_tabtxt" v-if="sytabactive == '2'">
          <el-tabs tab-position="top" v-model="activeNametwo" @tab-click="handleClicktwo">
            <el-tab-pane
              v-for="(item, index) in readingtwo"
              :key="index"
              :label="item.name"
              :name="item.name"
            >
              <div class="reading_txts" v-html="item.content"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="syzl_tabtxt" v-if="sytabactive == '3'">
          <div class="discuss_box">
            <div class="my_discuss" v-if="false">
              <div class="img_box">
                <img style="width:30px;border-radius:50%;height:30px;" v-if="$store.state.userdata.user.avatar" :src="$store.state.userdata.user.avatar" alt="">
                <img style="width:30px;border-radius:50%;height:30px;" v-else src="../../../static/images/defaultavimg.png" alt="">
              </div>
              <div class="input_box">
                <el-input type="textarea" v-model="textarea" :rows="4" placeholder="欢迎高质量的评论"></el-input>
                <div class="input_txt">
                  <span>还能输入 <em>{{1000 - textarea.length}}</em> 个字符</span>
                  <el-button style="margin-left:20px;" type="primary" round size="mini" @click="handlediscuss">评论</el-button>
                </div>
              </div>
            </div>
            <div class="discuss_list">
              <div class="discuss_item" v-for="(item,index) in discussList" :key="index">
                <div class="img_box">
                  <img style="width:30px;border-radius:50%;height:30px;" v-if="item.cover" :src="item.cover" alt="">
                  <img style="width:30px;border-radius:50%;height:30px;" v-else src="../../../static/images/defaultavimg.png" alt="">
                </div>
                <div class="content_box">
                  <div style="margin-bottom:5px;color:#777888;">
                    <span style="padding-right:4px;">{{item.outher}}</span><span>{{item.time}}</span>
                  </div>
                  <div>{{item.text}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 挪到首页了先隐藏 -->
      <div class="expert_list" v-if="false">
        <div class="expert_title">教学团队</div>
        <div class="expert_item">
          <div>
            <el-image
            style="width: 130px; height: 130px;border-radius:50%;"
            :src="require('../../../static/images/5-1.png')"
            fit="cover"></el-image>
            <p class="name">王清</p>
          </div>
          <div>
            <el-image
            style="width: 130px; height: 130px;border-radius:50%;"
            :src="require('../../../static/images/5-2.png')"
            fit="cover"></el-image>
            <p class="name">支刚</p>
          </div>
          <div>
            <el-image
            style="width: 130px; height: 130px;border-radius:50%;"
            :src="require('../../../static/images/5-3.png')"
            fit="cover"></el-image>
            <p class="name">宁金成</p>
          </div>
          <div>
            <el-image
            style="width: 130px; height: 130px;border-radius:50%;"
            :src="require('../../../static/images/5-4.png')"
            fit="cover"></el-image>
            <p class="name">刘芝梅</p>
          </div>
          <div>
            <el-image
            style="width: 130px; height: 130px;border-radius:50%;"
            :src="require('../../../static/images/5-5.jpg')"
            fit="cover"></el-image>
            <p class="name">孙振华</p>
          </div>
          <div>
            <el-image
            style="width: 130px; height: 130px;border-radius:50%;"
            :src="require('../../../static/images/5-6.jpg')"
            fit="cover"></el-image>
            <p class="name">闫海峰</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="登 录"
      :visible.sync="dialoglogin"
      width="500px"
      :close-on-click-modal="false"
      custom-class="dialogins"
      :before-close="handleClose"
    >
      <loginview ref="loginoff" @digshow="digshow"></loginview>
    </el-dialog>
  </div>
</template>
<script>
import loginview from "../login/index.vue";
import { calSize } from "@/utils";
import { parseTime } from '@/utils/ruoyi'
export default {
  name: "xndetails",
  data() {
    return {
      sucxinxi: null,
      tabPosition: "1", //视频切换
      sytabactive: "1", //介绍和必读切换
      activeName: "实验简介", //资料切换
      activeNametwo: "网络要求", //实验必读内容切换
      readingone: [],
      readingtwo: [],
      baseurl: this.$http.requrl,
      divloading: false, //防止重复点击
      dialoglogin: false, //登录弹出框
      filelist: null,
      zanloading: false, //点赞Loading
      textarea:'',
      discussList:[],


    };
  },
  components: {
    loginview,
  },
  filters: {
    calSize(fileSize) {
      return calSize(fileSize);
    },
  },
  watch: {
    "$store.state.userdata": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue !== null) {
          //登录后请求资源详情内的收藏 点赞等
          this.filedetailsg();
        }
      },
    },
  },
  created() {
    this.materialId = this.$route.query.id;
    //详情内容
    this.filedetailsg();
  },
  mounted() {},
  methods: {
    // 点击评论
    handlediscuss(){
      this.discussList.unshift({
        cover:this.$store.state.userdata.user.avatar||require('../../../static/images/defaultavimg.png'),
        outher:this.$store.state.userdata.user.nickName,
        text:this.textarea,
        time:parseTime(new Date(),'{y}.{m}.{d}')
      })
      this.textarea = ''
      this.$message.success('评论添加成功')
    },
    formatUrl(url) {
      return url == null
        ? url
        : url.startsWith("/profile")
        ? this.baseurl + url
        : this.baseurl + "/profile/" + url;
    },
    goDetail(item) {
      this.materialId = item.id;
      this.filedetailsg();
      let rourl = this.$router.resolve({
        path: "/xnfzdetails",
        query: { id: item.id, title: this.breadtitle },
      });
      window.open(rourl.href);
    },
    filedetailsg() {
      let userId = "";
      if (this.$store.state.userdata) {
        userId = this.$store.state.userdata.user.userId;
      }

      this.$http
        .get(
          "/business/material/details?materialId=" + this.materialId + "&userId=" + userId
        )
        .then((res) => {
          if (res.code == 200) {
            this.readingone = [];
            this.readingtwo = [];
            this.sucxinxi = res.data;
            this.sucxinxi.zykMaterialMenus.filter((val) => {
              if (val.type == 1) {
                this.readingone.push(val);
              } else if (val.type == 2) {
                this.readingtwo.push(val);
              }
            });
            // 相关推荐
            // this.recommend(this.sucxinxi.material.tag, this.sucxinxi.types);
            if(this.sucxinxi.material.title == '内科六大穿刺术(以小儿头皮静脉穿刺技术为例)'){
              this.discussList = [{
                cover:require('../../../static/images/1-2.jpg'),
                outher:'苦海123',
                text:'啊~~~学习了',
                time:'2022.07.30'
              },{
                cover:require('../../../static/images/1-3.jpg'),
                outher:'月谷丶',
                text:'不出门，知天下事，且身历其境',
                time:'2022.08.14'
              },{
                cover:require('../../../static/images/1-4.jpg'),
                outher:'includeevey',
                text:'学到了学到了，这样学习真的太棒了',
                time:'2022.09.09'
              },{
                cover:require('../../../static/images/1-1.jpg'),
                outher:'国服第二切图仔',
                text:'占楼！！！！中秋快乐楼友们',
                time:'2022.09.09'
              }]
            }else if(this.sucxinxi.material.title == '人体形态学虚拟仿真实验'){
              this.discussList = [{
                cover:require('../../../static/images/3-1.jpg'),
                outher:'Developer 小马',
                text:'顶',
                time:'2022.07.01'
              },{
                cover:require('../../../static/images/3-2.jpg'),
                outher:'1 + 1=王',
                text:'楼主666，知识点流程总结的非常的到位',
                time:'2022.08.30'
              },]
            }else if(this.sucxinxi.material.title == '机能学虚拟仿真实验'){
              this.discussList = [{
                cover:require('../../../static/images/2-1.jpg'),
                outher:'SuperProgMan.SYJ',
                text:'中国医学，强强强',
                time:'2022.09.01'
              },{
                cover:require('../../../static/images/2-2.jpg'),
                outher:'编程爱好者-阿新',
                text:'同感，但还是要低调，低调，低调发展',
                time:'2022.09.01'
              }]
            }else if(this.sucxinxi.material.title == '健康照护中心'){
              this.discussList = [{
                cover:require('../../../static/images/2-3.jpg'),
                outher:'小立爱学习',
                text:'现在科技真的很强大，看看这仿真做的，放在之前完全不敢想象',
                time:'2022.09.08'
              },{
                cover:require('../../../static/images/2-4.jpg'),
                outher:'国服第二切图仔',
                text:'无需感慨，在古代你能想象在天上飞吗？再看看现在！科技在发展，人类在进步',
                time:'2022.09.09'
              }]
            }else if(this.sucxinxi.material.title == '虚拟养老院实验系统'){
              this.discussList = [{
                cover:require('../../../static/images/3-3.jpg'),
                outher:'秦 羽',
                text:'踩一下踩一下，生动形象，身临其境',
                time:'2022.08.31'
              },{
                cover:require('../../../static/images/3-4.jpg'),
                outher:'东非不开森',
                text:'盖楼',
                time:'2022.09.11'
              }]
            }else{
              this.discussList = [{
                cover:require('../../../static/images/4-1.jpg'),
                outher:'极客飞兔',
                text:'收获很大，技术很新颖，也很有教学意义，支持!!!',
                time:'2022.09.09'
              },{
                cover:require('../../../static/images/4-2.jpg'),
                outher:'不渴望力量的哈士奇',
                text:'收获很大，技术很新颖，也很有教学意义，支持!!!',
                time:'2022.09.09'
              },{
                cover:require('../../../static/images/4-3.jpg'),
                outher:'张小姐的猫',
                text:'收获很大，技术很新颖，也很有教学意义，支持!!!',
                time:'2022.09.09'
              },{
                cover:require('../../../static/images/4-4.jpg'),
                outher:'孤寒者',
                text:'收获很大，技术很新颖，也很有教学意义，支持!!!',
                time:'2022.09.09'
              }]
            }
          }
        });
    },
    // 相关推荐
    recommend(keywords, types) {
      var newObjs = {};
      for (let i = 0; i < types.length; i++) {
        if (types[i].typeBigId == 2 || types[i].typeBigId == 3 || types[i].typeBigId == 4)
          newObjs["big" + types[i].typeBigId] = types[i].typeSmallId;
      }
      let datas = {
        keywords: keywords,
        status: 2,
        types: newObjs,
      };
      this.$http.post("/business/material/queryES?size=8&page=1", datas).then((res) => {
        if (res.code == 200) {
          this.filelist = res.rows;
        }
      });
    },
    // 上传的tabs列表
    handleClick(tab, event) {
      //   console.log(tab.name);
    },
    handleClicktwo(tab, event) {},
    zuopshiy() {
     let tookenLogin =  sessionStorage.getItem("tookenLogin")
     if(!tookenLogin)   return this.$message({ message: "您还没登陆，请先登录！",type: "error",offset: "120"});
      let url;
        if(this.sucxinxi.material.htmlUrl.indexOf('http') > -1 ||this.sucxinxi.material.htmlUrl.indexOf('https') > -1 ){
          url =  this.sucxinxi.material.htmlUrl;
        }else{
            url = this.baseurl + "/profile/" + this.sucxinxi.material.htmlUrl;
        }
        window.open(url);
    },
    // 查询用户信息
    userdata() {
      this.$http.get("/system/user/myDetail").then((res) => {
        if (res.code == 200) {
          let usdata = JSON.stringify(res.data);
          localStorage.setItem("userdata", usdata);
          if (localStorage.getItem("userdata")) {
            this.$store.commit("userdata", JSON.parse(localStorage.getItem("userdata")));
          }
        }
      });
    },
    //子组件传值
    digshow(val) {
      this.dialoglogin = val;
      this.handleClose();
    },
    //关闭登陆
    handleClose() {
      this.dialoglogin = false;
    },
    //收藏
    collction() {
      if (this.$store.state.tooken == null) {
        this.$message({
          message: "请先登陆再进行操作",
          type: "warning",
        });
        this.dialoglogin = true;
        return;
      }
      let datas = {
        collectBy: this.$store.state.userdata.user.userId, //收藏人ID
        materialId: this.materialId,
      };
      this.sucxinxi.collected = !this.sucxinxi.collected;
      this.$http.post("/business/collect", datas).then((res) => {
        if (res.code == 200) {
        } else {
          this.sucxinxi.collected = !this.sucxinxi.collected;
        }
      });
    },
    // 分享
    copyurls() {
      let copyurl = window.location.href;
      this.CVcopy(copyurl);
    },
    // 复制文本
    CVcopy(data) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", data);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("资源链接复制成功");
      } else {
        this.$message.error("资源链接复制失败");
      }
      document.body.removeChild(input);
    },
    // 点赞
    fabuloubtns(operate) {
      if (this.$store.state.tooken == null) {
        this.$message({
          message: "请先登陆再进行操作",
          type: "warning",
          offset: 150,
        });
        this.dialoglogin = true;
        return;
      }
      this.zanloading = true;
      let formdata = new FormData();
      formdata.append("materialId", Number(this.materialId));
      formdata.append("operate", operate);
      this.$http
        .post("/business/material/pros", formdata)
        .then((res) => {
          this.zanloading = false;
          this.filedetailsg();
        })
        .catch((err) => {
          this.zanloading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.xndetails {
  width: 100%;
  overflow: hidden;
  // 头部简介
  .header_top {
    // filter: blur(3px);
    width: 100%;
    margin-top: 100px;
    min-height: 380px;
    overflow: hidden;
    position: relative;
    // background-color: #2f3a59;
    background: url('../../../static/images/schoolbg.jpeg') no-repeat center center;
    background-size: 100% 100%;

    .light:after {
      content: "";
      display: block;
      position: absolute;
      width: 960px;
      height: 580px;
      top: -220px;
      left: -200px;
      // background: rgba(116, 69, 103, 1);
      // background: -moz-radial-gradient(
      //   center,
      //   ellipse cover,
      //   rgba(116, 69, 103, 1) 0%,
      //   rgba(116, 69, 103, 1) 22%,
      //   rgba(106, 65, 102, 1) 35%,
      //   rgba(86, 60, 93, 1) 46%,
      //   rgba(47, 58, 89, 1) 66%,
      //   rgba(47, 58, 89, 1) 100%
      // );
      // background: -webkit-gradient(
      //   radial,
      //   center center,
      //   0px,
      //   center center,
      //   100%,
      //   color-stop(0%, rgba(116, 69, 103, 1)),
      //   color-stop(22%, rgba(116, 69, 103, 1)),
      //   color-stop(35%, rgba(106, 65, 102, 1)),
      //   color-stop(46%, rgba(86, 60, 93, 1)),
      //   color-stop(66%, rgba(47, 58, 89, 1)),
      //   color-stop(100%, rgba(47, 58, 89, 1))
      // );
      // background: -webkit-radial-gradient(
      //   center,
      //   ellipse cover,
      //   rgba(116, 69, 103, 1) 0%,
      //   rgba(116, 69, 103, 1) 22%,
      //   rgba(106, 65, 102, 1) 35%,
      //   rgba(86, 60, 93, 1) 46%,
      //   rgba(47, 58, 89, 1) 66%,
      //   rgba(47, 58, 89, 1) 100%
      // );
      // background: -o-radial-gradient(
      //   center,
      //   ellipse cover,
      //   rgba(116, 69, 103, 1) 0%,
      //   rgba(116, 69, 103, 1) 22%,
      //   rgba(106, 65, 102, 1) 35%,
      //   rgba(86, 60, 93, 1) 46%,
      //   rgba(47, 58, 89, 1) 66%,
      //   rgba(47, 58, 89, 1) 100%
      // );
      // background: -ms-radial-gradient(
      //   center,
      //   ellipse cover,
      //   rgba(116, 69, 103, 1) 0%,
      //   rgba(116, 69, 103, 1) 22%,
      //   rgba(106, 65, 102, 1) 35%,
      //   rgba(86, 60, 93, 1) 46%,
      //   rgba(47, 58, 89, 1) 66%,
      //   rgba(47, 58, 89, 1) 100%
      // );
      // background: radial-gradient(
      //   ellipse at center,
      //   rgba(116, 69, 103, 1) 0%,
      //   rgba(116, 69, 103, 1) 22%,
      //   rgba(106, 65, 102, 1) 35%,
      //   rgba(86, 60, 93, 1) 46%,
      //   rgba(47, 58, 89, 1) 66%,
      //   rgba(47, 58, 89, 1) 100%
      // );
      // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#744567', endColorstr='#2f3a59', GradientType=1);
    }
    .light {
      position: absolute;
      width: 1200px;
      height: 100%;
      left: 50%;
      margin-left: -600px;
    }
    // 简介内容
    .hdtop_content {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      vertical-align: top;
      z-index: 99;
      .hdcontent_left {
        width: 65%;
        float: left;

        h1 {
          font-weight: 400;
          font-size: 24px;
          letter-spacing: 1px;
          margin-top: 50px;
          line-height: 1.5;
          color: #fff;
          .zhen-icon {
            font-size: 12px;
            background: #50ddbb;
            padding: 0 5px 0 8px;
            margin-left: 10px;
            display: inline-block;
            vertical-align: middle;
            position: relative;
            height: 22px;
            line-height: 22px;
            color: #fff;
          }
          .zhen-icon:after {
            content: "";
            position: absolute;
            font-size: 0;
            height: 0;
            width: 0;
            border-top: 11px solid transparent;
            border-bottom: 11px solid transparent;
            border-left: 8px solid #50ddbb;
            top: 0;
            right: -8px;
          }
        }
        // 按钮操作
        .left_listbtn {
          display: flex;
          margin: 10px 0;
          .lefbtn {
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            color: #fff;
            border: none;
            border-radius: 3px;
            padding: 0 10px;
            margin-right: 10px;
            cursor: pointer;
            position: relative;
            display: inline-block;
            vertical-align: middle;
            .goodicon {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url("../../../static/images/good.png") no-repeat;
              background-size: cover;
              color: #fff;
              vertical-align: sub;
            }
          }
        }
        //资源信息
        .ziy_miaoshu {
          margin: 10px 0;
          font-size: 14px;
          color: #fff;
          opacity: 0.5;
          margin-left: -20px;
          span {
            margin-left: 20px;
          }
        }
        // 所属专业类
        .ziy_class {
          display: flex;
          flex-wrap: wrap;
          .type_list {
            padding: 5px 30px 0 0;
            span {
              font-size: 14px;
              width: 100%;
              color: #fff;
              opacity: 0.5;
              margin-top: 15px;
              line-height: 20px;
            }
          }
        }
        // 介绍
        .zy_detailtxt {
          margin-top: 15px;
          font-size: 14px;
          line-height: 22px;
          min-height: 100px;
          p {
            color: #fff;
            margin: 0 0 10px;
          }
        }
        // 实验链接
        .shiy_link {
          margin-bottom: 20px;
          .shiy_btn {
            background-color: #50ddbb;
            color: #fff;
            border: none;
          }
        }
      }
      //   右侧视频
      .hdcontent_rig {
        width: 33%;
        float: right;
        padding-top: 50px;
        user-select: none;
        overflow: hidden;

        .tabs_rig {
          margin-left: 35px;
          //radio-button 切换
          ::v-deep .is-active {
            .el-radio-button__orig-radio:checked + .el-radio-button__inner {
              background-color: #50ddbb !important;
              border: none;
            }
          }
          ::v-deep .el-radio-button__inner {
            &:hover {
              color: #000;
            }
          }
          //   视频
          .vid_active {
            width: 360px;
            height: 250px;
            float: right;
            .emnull {
              width: 240px;
              height: 200px;
              text-align: center;
            }
            video {
              width: 100%;
              height: 230px;
              margin-top: 15px;
            }
          }
        }
      }
    }
  }
  //收藏
  .icolora {
    background-color: #b09fb2;
  }

  .icolorb {
    background-color: #50ddbb !important;
  }
  //   资料简介
  .shiy_tab {
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    margin-bottom: 20px;
    .shiy_center {
      width: 1200px;
      margin: 0 auto;
      user-select: none;
      display: flex;
      align-items: center;
      .sharing{
        display: flex;
        align-items: center;
        margin-left: 20px;
        border-left: 1px solid #e0e0e0;
        text-align: center;
        .sharing_item{
          margin-left: 16px;
        }
        .sharing_title{
          font-size: 14px;
          color:#50ddbb;
          margin-bottom: 10px;
        }
      }
      // tab切换
      ::v-deep .is-active {
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background-color: #50ddbb !important;
          border: 1px solid #dcdfe6;
          box-shadow: none !important;
        }
      }
      ::v-deep .el-radio-button__inner {
        border: 1px solid #dcdfe6;
        &:hover {
          color: #000;
        }
      }
    }
  }
  //  资料内容
  .syzl_listall {
    width: 100%;
    background-color: #f4f4f4;
    .syzl_content {
      width: 1200px;
      min-height: 800px;
      background-color: #fff;
      margin: 20px auto;
      padding: 20px 30px;
      .syzl_tabtxt {
        .editor—wrapper,
        .reading_txts {
         ::v-deep img{
            max-width: 100% !important;
            height: 100%;
          }
          pre {
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            white-space: pre-wrap;
            word-wrap: break-word;
          }

          ::v-deep table {
            width: auto !important;
            max-width: 100% !important;
            margin: 0 auto;
            text-align: center;
            border-collapse: collapse;
            table-layout: fixed;
            border-radius: 5px;
            margin: 10px auto;
            border: 2px solid #e0e0e0;

            tbody {
              tr,
              td,
              th {
                border: 1px solid #e0e0e0;
                vertical-align: middle;
              }
              td,
              th {
                padding: 5px;
              }
            }
          }
        }
      }
      .discuss_box{
        .my_discuss{
          display: flex;
          .img_box{
            width: 30px;
            margin-right: 20px;
            padding-top: 10px;
          }
          .input_box{
            flex:1;
            background: rgba(245,246,247,0.8);
            font-size: 14px;
            border-radius: 8px;
            overflow: hidden;
            padding: 14px 0;
            ::v-deep{
              .el-textarea__inner{
                border: none;
                background: transparent;
              }
            }
            .input_txt{
              padding-left: 20px;
              color: #999aaa;
            }
          }
        }
        .discuss_list{
          .discuss_item{
            display: flex;
            .img_box{
              width: 30px;
              margin-right: 10px;
              padding-top: 20px;
            }
            .content_box{
              flex:1;
              padding: 20px 0;
            }
          }
        }
      }
    }
    .expert_list{
      width: 1200px;
      margin: 0 auto;
      background: #fff;
      padding: 30px;
      margin-bottom: 30px;
      .expert_title{
        text-align: center;
        font-size: 30px;
        margin-bottom: 50px;
        font-weight: bold;
      }
      .expert_item{
        display: flex;
        justify-content: space-around;
      }
      .name{
        text-align: center;
        margin-top: 3px;
      }
    }
  }
  // 相关推荐
  /* 空数据时 */
  .emptyall {
    width: 100%;
    height: 300px;
    text-align: center;
  }

  .file_listall {
    width: 100%;
    background-color: #fff;

    .file_list {
      width: 1240px;
      margin: 20px auto;
      padding-bottom: 30px;
      overflow: hidden;
      padding: 0 20px;

      .file_listtuij {
        width: 100%;
        text-align: center;
        padding: 30px 0 10px 0;
        font-size: 30px;

        font-weight: 400;
        color: #333333;
      }

      /* 资源列表 */
      .modelist {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        padding-bottom: 50px;
        margin-left: -20px;
      }

      .achie_model {
        width: 280px;
        height: 286px;
        border-radius: 10px;
        background-color: #fff;
        overflow: hidden;
        cursor: pointer;
        margin: 25px 0 0 20px;
        transition: all 0.4s;
        border: 1px solid #eeeeee;
      }

      .achie_tops {
        height: 158px;
        border-radius: 3px;
        overflow: hidden;
      }

      .achie_model:hover {
        box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
      }

      .achie_model:hover img {
        transform: scale(1.2);
      }

      .achie_tops > .el-image {
        width: 100%;
        height: 100%;
        transition: all 0.4s;
      }

      /* 介绍 */
      .achie_text {
        width: 100%;
        font-size: 14px;
        color: gray;
        font-weight: bold;
      }

      .achiebotms {
        height: 49px;
        line-height: 38px;
        padding: 6px 10px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        border-bottom: 1px solid #f2f2f2;
      }

      .achie_sp {
        width: 100%;
        height: 30px;
        padding: 6px 10px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
      }

      .txtp1,
      .txtp2 {
        min-height: 25px;
      }

      .txtp1 {
        width: 60%;
        text-align: left;
      }

      .txtp2 {
        width: 40%;
        text-align: right;
      }

      .txtp3 {
        width: 100%;
        min-height: 25px;
      }

      .txtcolors {
        color: #b3b3b3;
      }
    }
  }
}
</style>
